import { Carousel, Card } from "react-bootstrap";
import img1 from "../../../../assets/images/exalumno2.jpg";
import img2 from "../../../../assets/images/exalumno60.jpg";
import img3 from "../../../../assets/images/exalumno9.jpg";
import img4 from "../../../../assets/images/exalumno60.jpg";

const imagenesExalumnos = [
  { src: img1, alt: "Exalumno 1" },
  { src: img2, alt: "Exalumno 2" },
  { src: img3, alt: "Exalumno 3" },
  { src: img4, alt: "Exalumno 4" },
];

function ExalumnosSection() {
  return (
    <div className="container my-5">
      <Card className="bg-dark text-white shadow-lg border-0 rounded-4 p-4" data-aos="fade-right">
        <Card.Body>
          <h2 className="text-center fw-bold mb-4" style={{ color: "yellow" }}>
            EXALUMNOS
          </h2>
          <div className="d-flex flex-column flex-md-row align-items-center justify-content-center gap-4">
            {/* Carrusel de imágenes */}
            <div className="w-100" style={{ maxWidth: "500px", height: "420px", overflow: "hidden" }}>
              <Carousel>
                {imagenesExalumnos.map((imagen, index) => (
                  <Carousel.Item key={index}>
                    <img className="d-block w-100" src={imagen.src} alt={imagen.alt}  style={{
                        height: "420px",
                        objectFit: "cover",
                        objectPosition: "top",
                        borderRadius: "10px",
                      }}
                    />
                  </Carousel.Item>
                ))}
              </Carousel>
            </div>

            {/* Texto */}
            <div
              style={{
                maxWidth: "600px",
                textAlign: "justify",
                color: "#f8f9fa",
                fontSize: "18px",
                lineHeight: "1.6",
              }}
            >
              <p className="fw-bold">
                Ser parte del Colegio Santo Tomás es una experiencia que trasciende el tiempo. Cada promoción deja una huella
                en nuestra historia, y cada exalumno sigue siendo parte de esta comunidad educativa que valora el aprendizaje,
                los vínculos y los valores que nos formaron.
              </p>
              <p className="fw-bold">
                Queremos seguir construyendo puentes con quienes compartieron sus años escolares con nosotros, celebrando los
                logros, compartiendo recuerdos y generando nuevas oportunidades de encuentro.
              </p>
            </div>
          </div>
        </Card.Body>
      </Card>
    </div>
  );
}

export default ExalumnosSection;
